import { whenDocumentReady } from '../../../../assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    let videos = document.querySelectorAll("video");
    videos.forEach((video) => {
        if (video.muted && video.autoplay ) {
            let playPromise = video.play();
            if (playPromise !== undefined) {
                playPromise.then((_) => {
                    let observer = new IntersectionObserver(
                        (entries) => {
                            entries.forEach((entry) => {
                                if (
                                    entry.intersectionRatio == 0 &&
                                    !video.paused
                                ) {
                                    video.pause();
                                } else if (video.paused) {
                                    video.play();
                                }
                            });
                        },
                        {threshold: 0}
                    );
                    observer.observe(video);
                });
            }
        }
    });
}